import { isUndefined } from "lodash";
import { API_EXCEL } from "shared/constants";
import { isBlankOrNull } from "utils";

export const formatCol = (rowSelectionModel, rows) => {
  // return [];
  if (!rowSelectionModel.length) return [];
  let data = [];
  for (const rowSelect of rowSelectionModel) {
    for (const item of rows) {
      if (rowSelect?.rowNumber === item?.rowNumber) {
        data.push({
          [API_EXCEL.ROW_NUMBER]: isBlankOrNull(rowSelect?.rowNumber) ? item?.rowNumber : rowSelect?.rowNumber,
          [API_EXCEL.FIELD]: isBlankOrNull(rowSelect?.field) ? item?.field : rowSelect?.field,
          [API_EXCEL.DISPLAY_NAME]: isBlankOrNull(rowSelect?.displayName) ? item?.displayName : rowSelect?.displayName,
          [API_EXCEL.ORDER_DISPLAY]: isBlankOrNull(rowSelect?.ordDisp) ? item?.ordDisp : rowSelect?.ordDisp,
          [API_EXCEL.PK]: isBlankOrNull(rowSelect?.pk) ? item?.pk : rowSelect?.pk,
          [API_EXCEL.DATA_TYPE]: item?.dataType,
          [API_EXCEL.CRITERIA]: isBlankOrNull(rowSelect?.criteria) ? item?.criteria : rowSelect?.criteria,
          [API_EXCEL.LOGICAL_OPERATION]: isBlankOrNull(rowSelect?.logOpr) ? item?.logOpr : rowSelect?.logOpr,
          [API_EXCEL.DISPLAY_OPTION]: isBlankOrNull(rowSelect?.dispOpt)
            ? `${Number(item.dispOpt)}`
            : `${Number(rowSelect.dispOpt)}`,
          [API_EXCEL.SORT]: isBlankOrNull(rowSelect?.[API_EXCEL.SORT])
            ? item?.[API_EXCEL.SORT]
            : rowSelect?.[API_EXCEL.SORT],
        });
        break;
      }
    }
  }
  return data;
};
export const formatColForCreateBookmark = (rows, rowSelectionModel) => {
  let data = [];
  if (!rowSelectionModel.length) {
    data = rows?.map(item => ({
      [API_EXCEL.ROW_NUMBER]: isUndefined(item?.rowNumber) ? "" : item?.rowNumber,
      [API_EXCEL.FIELD]: isUndefined(item?.field) ? "" : item?.field,
      [API_EXCEL.DISPLAY_NAME]: isUndefined(item?.displayName) ? "" : item?.displayName,
      [API_EXCEL.ORDER_DISPLAY]: isUndefined(item?.ordDisp) ? "" : item?.ordDisp,
      [API_EXCEL.PK]: isUndefined(item?.pk) ? "" : item?.pk,
      [API_EXCEL.DATA_TYPE]: isUndefined(item?.dataType) ? "" : item?.dataType,
      [API_EXCEL.CRITERIA]: isUndefined(item?.criteria) ? "" : item?.criteria,
      [API_EXCEL.LOGICAL_OPERATION]: isUndefined(item?.logOpr) ? "" : item?.logOpr,
      [API_EXCEL.DISPLAY_OPTION]: `${Number(item.dispOpt)}`,
      [API_EXCEL.SORT]: isUndefined(item?.[API_EXCEL.SORT]) ? "" : item?.[API_EXCEL.SORT],
    }));
    return data;
  } else {
    let temp;
    data = [];
    for (const item of rows) {
      console.log("rowSelectionModel", rowSelectionModel, rows);
      const rowSelect = rowSelectionModel.find(selected => selected.rowNumber === item.rowNumber);
      if (rowSelect) {
        console.log("in", rowSelect);
        temp = {
          [API_EXCEL.ROW_NUMBER]: isBlankOrNull(rowSelect?.rowNumber) ? item?.rowNumber : rowSelect?.rowNumber,
          [API_EXCEL.FIELD]: isBlankOrNull(rowSelect?.field) ? item?.field : rowSelect?.field,
          [API_EXCEL.DISPLAY_NAME]: isBlankOrNull(rowSelect?.displayName) ? item?.displayName : rowSelect?.displayName,
          [API_EXCEL.ORDER_DISPLAY]: isBlankOrNull(rowSelect?.ordDisp) ? item?.ordDisp : rowSelect?.ordDisp,
          [API_EXCEL.PK]: isBlankOrNull(rowSelect?.pk) ? item?.pk : rowSelect?.pk,
          [API_EXCEL.DATA_TYPE]: item?.dataType,
          [API_EXCEL.CRITERIA]: isBlankOrNull(rowSelect?.criteria) ? item?.criteria : rowSelect?.criteria,
          [API_EXCEL.LOGICAL_OPERATION]: isBlankOrNull(rowSelect?.logOpr) ? item?.logOpr : rowSelect?.logOpr,
          [API_EXCEL.DISPLAY_OPTION]: `${Number(item.dispOpt)}`,
          [API_EXCEL.SORT]: isBlankOrNull(rowSelect?.[API_EXCEL.SORT])
            ? item?.[API_EXCEL.SORT]
            : rowSelect?.[API_EXCEL.SORT],
        };
      } else {
        temp = {
          [API_EXCEL.ROW_NUMBER]: isUndefined(item?.rowNumber) ? "" : item?.rowNumber,
          [API_EXCEL.FIELD]: isUndefined(item?.field) ? "" : item?.field,
          [API_EXCEL.DISPLAY_NAME]: isUndefined(item?.displayName) ? "" : item?.displayName,
          [API_EXCEL.ORDER_DISPLAY]: isUndefined(item?.ordDisp) ? "" : item?.ordDisp,
          [API_EXCEL.PK]: isUndefined(item?.pk) ? "" : item?.pk,
          [API_EXCEL.DATA_TYPE]: isUndefined(item?.dataType) ? "" : item?.dataType,
          [API_EXCEL.CRITERIA]: isUndefined(item?.criteria) ? "" : item?.criteria,
          [API_EXCEL.LOGICAL_OPERATION]: isUndefined(item?.logOpr) ? "" : item?.logOpr,
          [API_EXCEL.DISPLAY_OPTION]: `${Number(item.dispOpt)}`,
          [API_EXCEL.SORT]: isUndefined(item?.[API_EXCEL.SORT]) ? "" : item?.[API_EXCEL.SORT],
        };
      }
      data.push(temp);
    }

    return data;
  }
};
